import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import AdminHeader from "../components/AdminHeader";
import { Trash2, UserPlus, ShieldCheck, User } from "lucide-react";

export default function Users() {
  const [users, setUsers] = useState([]);
  const [form, setForm] = useState({ username: "", pin: "", name: "", role: "staff" });

  const load = () => api.get("/users").then((r) => setUsers(r.data));
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!form.username.trim() || !form.pin.trim() || !form.name.trim()) { toast.error("Fill all fields"); return; }
    try {
      await api.post("/users", form);
      toast.success("User created");
      setForm({ username: "", pin: "", name: "", role: "staff" });
      load();
    } catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };

  const remove = async (u) => {
    if (!window.confirm(`Delete ${u.name}?`)) return;
    try { await api.delete(`/users/${u.id}`); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };

  const inputCls = "h-14 rounded-xl bg-[#09090B] border border-white/10 px-4 text-white outline-none focus:border-[#FF007F]";

  return (
    <div className="min-h-screen bg-[#09090B] p-4 md:p-6">
      <AdminHeader title="USERS" accent="#00FA9A" />
      <div className="bg-[#18181B] border border-white/10 rounded-2xl p-5 mb-6 grid grid-cols-1 md:grid-cols-5 gap-3">
        <input data-testid="user-name-input" className={inputCls} placeholder="Full name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
        <input data-testid="user-username-input" className={inputCls} placeholder="Username" value={form.username} onChange={(e) => setForm({ ...form, username: e.target.value })} />
        <input data-testid="user-pin-input" className={inputCls} placeholder="PIN" inputMode="numeric" value={form.pin} onChange={(e) => setForm({ ...form, pin: e.target.value })} />
        <select data-testid="user-role-select" className={inputCls} value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })}>
          <option value="staff">Staff</option>
          <option value="admin">Administrator</option>
        </select>
        <button data-testid="add-user-button" onClick={add}
          className="h-14 px-4 rounded-xl bg-[#FF007F] text-white font-display font-black tracking-wide flex items-center justify-center gap-2 active:scale-95 transition-transform duration-75">
          <UserPlus className="w-5 h-5" /> ADD
        </button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {users.map((u) => (
          <div key={u.id} data-testid={`user-row-${u.id}`} className="bg-[#18181B] border border-white/10 rounded-2xl p-5 flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-xl bg-[#27272A] flex items-center justify-center">
                {u.role === "admin" ? <ShieldCheck className="w-6 h-6 text-[#00FA9A]" /> : <User className="w-6 h-6 text-[#00F0FF]" />}
              </div>
              <div>
                <div className="font-display font-black text-lg text-white">{u.name}</div>
                <div className="text-[#71717A] text-sm">@{u.username} · <span className="uppercase tracking-widest text-xs">{u.role}</span></div>
              </div>
            </div>
            <button data-testid={`delete-user-${u.id}`} onClick={() => remove(u)}
              className="w-11 h-11 rounded-lg bg-[#27272A] hover:bg-[#FF3B30] text-white flex items-center justify-center active:scale-95 transition-transform duration-75">
              <Trash2 className="w-5 h-5" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
